export const lightTheme = {
  colors: {
    background: "#ffffff",
    primary: "#FF2020",
    secondary: "DF5F5F",
    hover: "black",
    header: "#FFFFFF",
    headerText: "#444444",
    footer: "#FFFFFF",
    footerText: "#999999",
    border: "#999999",
    content: "#222222",
    text: "#222222",
    subText: "#888888",
    cardBackground: "#FFFFFF",
    hashText: "#aaaaaa",
    black: "#222222",
    white: "#FFFFFF",
    overlay: "rgba(0, 0, 0, 0.5)",
  },
};

export const darkTheme = {
  colors: {
    background: "#121212",
    primary: "#FF4D4D",
    secondary: "#E57373",
    hover: "white",
    header: "#121212",
    headerText: "#E0E0E0",
    footer: "#121212",
    footerText: "#888888",
    border: "#888888",
    content: "#F5F5F5",
    text: "#F5F5F5",
    subText: "#A0A0A0",
    cardBackground: "#1E1E1E",
    hashText: "#8d8d8d",
    black: "#FFFFFF",
    white: "#222222",
    overlay: "rgba(0, 0, 0, 0.5)",
  },
};
